import { Component, OnInit, ViewChild, ErrorHandler } from '@angular/core';

import { NgForm, FormGroup, FormControl } from '@angular/forms';

import { Http, Response } from '@angular/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, config } from 'rxjs';

import { Router, Route, ActivatedRoute } from '@angular/router';

import { UserService } from '../services/user.service';
import { User } from 'models/user.model';
import { error } from 'protractor';

import { TranslateService } from '@ngx-translate/core';

import { ToastContainerDirective, ToastrService, ToastContainerModule } from 'ngx-toastr';
import { TooltipPosition } from '@angular/material';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})
export class ResetComponent implements OnInit {

  password: string;
  ConfirmPasswordText: string;
  passwordPattern = "^[A-Z][a-z]{7,}";

  positionOptions: TooltipPosition[] = ['above'];
  position = new FormControl(this.positionOptions[0]);

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private toastr: ToastrService

  ) { }

  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
  }

  EditPassword(Password) {
    const Username = this.route.snapshot.paramMap.get('username');
    const Random = this.route.snapshot.paramMap.get('random');
    const IsWebUser = true;

    this.userService.resetPassword(Username, Password, Random, IsWebUser)
      .subscribe(
        data => {
          this.router.navigate(['/']);
          this.translate.get('RESET_PASSWORD_200.TITLE').subscribe((res: string) => {
            this.toastr.success(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            })
          });
        },
        error => {
          if (error.status == 500) {
            this.router.navigate(['/errorPage'])
          }
        });
  }

}
